import ccEmail from '@/api/cc_emails'

export default ({ commit }) => {
  return new Promise((resolve, reject) => {
    ccEmail.getCcEmail(result => {
      commit('setCcEmail', result.data.data.emails)
      resolve(result.data.data.emails)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/actions/getCcEmail.js